import { TweenMax, Expo } from 'gsap';

class Marker extends window.google.maps.OverlayView {
  constructor(params) {
    super();

    this.latlng = params.latlng;
    this.markup = params.markup;
    this.url = params.url;

    this.setMap(params.map);
  }

  get position() {
    return this.latlng;
  }

  get draggable() {
    return false;
  }

  createMarker = () => {
    this.marker = document.createElement('div');
    this.marker.style.position = 'absolute';

    if (this.markup) this.marker.innerHTML = this.markup;

    const button = this.marker.querySelector('.map__marker-button');

    window.google.maps.event.addDomListener(this.marker, 'click', () => {
      window.google.maps.event.trigger(this, 'click');

      window.location.href = this.url;
    });

    window.google.maps.event.addDomListener(this.marker, 'mouseenter', () => {
      TweenMax.fromTo(
        button,
        0.2,
        { scale: 1 },
        { scale: 3, ease: Expo.easeOut }
      );

      window.google.maps.event.trigger(this, 'mouseenter');
    });

    window.google.maps.event.addDomListener(this.marker, 'mouseleave', () => {
      TweenMax.fromTo(
        button,
        0.2,
        { scale: 3 },
        { scale: 1, ease: Expo.easeOut }
      );

      window.google.maps.event.trigger(this, 'mouseleave');
    });
  }

  appendMarkerToOverlay = () => {
    const panes = this.getPanes();

    panes.floatPane.appendChild(this.marker);
  }

  positionMarker = () => {
    const point = this.getProjection().fromLatLngToDivPixel(this.latlng);

    if (point) {
      this.marker.style.left = `${point.x}px`;
      this.marker.style.top = `${point.y}px`;
    }
  }

  draw = () => {
    if (!this.marker) {
      this.createMarker();
      this.appendMarkerToOverlay();
    }

    this.positionMarker();
  }

  remove = () => {
    if (this.marker) {
      this.marker.parentNode.removeChild(this.marker);
      this.marker = null;
    }
  }
}

export default Marker;
